module.exports = __webpack_public_path__ + "img/full_logo.a7b8c814.png";